import "../../css/widgets/widgets.css";

import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone } from '@fortawesome/fontawesome-svg-core/import.macro';
import { Row, Col, Form } from 'react-bootstrap';
import React, { useState, useEffect, useRef, memo } from 'react';
import MonitorWSService from '../../services/monitorwsservice';
import { PieChart, Series, Size, Connector, Legend, Animation } from 'devextreme-react/pie-chart';
import WidgetSettings from "./widgetSettings"
import { removeWidget } from "../../redux/supervisorSlice";
import { selectionTypes } from "../utils/consts";
import WidgetTools from "./widgetTools";
import { CircularGauge, Scale, Tick, Label, RangeContainer, Range, MinorTick } from 'devextreme-react/circular-gauge';
import { Switch } from "devextreme-react";
import { NumberBox } from "devextreme-react/number-box";

const MemoizedGauge = memo(({ value, objective }) => {
    return (
        <CircularGauge id="gauge" value={value}>
            <Scale startValue={0} endValue={100}>
                <Label visible={true} indentFromTick={20} font={{ size: 14 }} />
                <Tick visible={false} />
                <MinorTick visible={false} />
            </Scale>
            <RangeContainer offset={10} width={30}>
                <Range startValue={0} endValue={objective} color="#f1416c" />
                <Range startValue={objective} endValue={100} color="#50cd89" />
            </RangeContainer>
            <Animation enabled={false} />
        </CircularGauge>
    );
}, (prevProps, nextProps) => {
    return prevProps.value === nextProps.value && prevProps.objective === nextProps.objective;
});


function ServiceQuality(props) {

    const { t } = useTranslation();
    const [all, setAll] = useState(0);
    const [attended, setAttended] = useState(0);
    const [attendedPercentage, setAttendedPercentage] = useState(0);
    const [calls, setCalls] = useState([]);
    const [animation, setAnimation] = useState(true);
    const [showSettings, setShowSettings] = useState(false);
    const [groupId, setGroupId] = useState(-1);
    const [groupName, setGroupName] = useState(localStorage.getItem(`ServiceQuality_groupName_${props.identifier}_user${props.id}`) || t("all2"));
    const [highQuality, setHighQuality] = useState(JSON.parse(localStorage.getItem(`ServiceQuality_highQuality_${props.identifier}_user${props.id}`) || "20"));
    const [objective, setObjective] = useState(JSON.parse(localStorage.getItem(`ServiceQuality_objective_${props.identifier}_user${props.id}`) || "80"));
    const [highQualityPercentage, setHighQualityPercentage] = useState(0);
    const [showCalls, setShowCalls] = useState(JSON.parse(localStorage.getItem(`ServiceQuality_showCalls_${props.identifier}_user${props.id}`) || "false"));
    const [showConfig, setShowConfig] = useState(false);
    const wrapperRef = useRef(null);

    useEffect(() => {
        // component mounts
        return () => {
            // component unmounts
            if (MonitorWSService?.stompClient?.connected) {
                MonitorWSService.stompClient.send(`/app/unsubscribe/servicequality`, {}, JSON.stringify({
                    token: `${props.token}_${props.identifier}`,
                }));

                MonitorWSService.stompClient.unsubscribe(`servicequality_${props.identifier}`);
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (showConfig && wrapperRef.current && !wrapperRef.current.contains(e.target)) {
                setShowConfig(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [showConfig]);

    useEffect(() => {
        if (props.connected) {

            let groupId = parseInt(localStorage.getItem(`ServiceQuality_groupId_${props.identifier}_user${props.id}`) || -1);
            setGroupId(groupId);

            MonitorWSService.stompClient.subscribe(`/user/${props.token}/topic/servicequality_${props.identifier}/`, updateData, { id: `servicequality_${props.identifier}` });

            MonitorWSService.stompClient.send("/app/subscribe/servicequality", {}, JSON.stringify({
                token: props.token,
                widgetId: props.identifier,
                highQuality: highQuality,
                mediumQuality: 40,
                groupId: groupId
            }));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.connected]);


    const updateData = (callssummary) => {

        if (!document.hidden && localStorage.getItem("resizing") !== "true") {

            let data = JSON.parse(callssummary.body);
            if (all != data.totalCalls && attended != data.answered) {

                let answered = (data.answered / data.totalCalls) * 100;
                let missed = 100 - answered;
                let highQualityPercentage = (data.highQualityAttCalls / data.totalCalls) * 100;

                if (isNaN(highQualityPercentage))
                    highQualityPercentage = 0;

                if (highQualityPercentage % 1 > 0)
                    highQualityPercentage = highQualityPercentage.toFixed(1);

                if (isNaN(answered)) {
                    answered = 0;
                } else {
                    answered = Math.round(answered);
                }

                setAll(prev => prev === data.totalCalls ? prev : data.totalCalls);
                setAttended(prev => prev === data.answered ? prev : data.answered);
                setAttendedPercentage(prev => prev === answered ? prev : answered);
                setHighQualityPercentage(prev => prev === highQualityPercentage ? prev : highQualityPercentage);

                setCalls(prev => {
                    const newCalls = [
                        { state: t("answered"), amount: answered },
                        { state: t("missed"), amount: missed }
                    ];
                    const same = prev.length === newCalls.length && prev.every((v, i) => v.state === newCalls[i].state && v.amount === newCalls[i].amount);
                    return same ? prev : newCalls;
                });

                //disables flickering
                if (animation) {
                    setTimeout(() => {
                        setAnimation(false);
                    }, 1000);
                }

            }
        }
    }

    const toggleSettings = () => {
        setShowSettings(!showSettings);
    };

    const setGroup = (groupId, groupName) => {
        setShowSettings(!showSettings);
        setGroupId(groupId);
        setGroupName(groupName);
        localStorage.setItem(`ServiceQuality_groupId_${props.identifier}_user${props.id}`, groupId);
        localStorage.setItem(`ServiceQuality_groupName_${props.identifier}_user${props.id}`, groupName);
        MonitorWSService.stompClient.send("/app/subscribe/servicequality", {}, JSON.stringify({
            token: props.token,
            widgetId: props.identifier,
            highQuality: highQuality,
            mediumQuality: 40,
            groupId: groupId
        }));

    };

    const closeWidget = (e) => {
        e.preventDefault();
        props.close(props.identifier);
    }



    const customizePoint = (e) => {
        if (e.argument === t("answered")) {
            return {
                color: "#50cd89"
            }
        }
        if (e.argument === t("missed")) {
            return {
                color: "#f1416c"
            }
        }
    }

    const toggleConfig = () => {
        setShowConfig(!showConfig);
    }

    const handleSend = (e) => {

        localStorage.setItem(`ServiceQuality_highQuality_${props.identifier}_user${props.id}`, highQuality);
        localStorage.setItem(`ServiceQuality_objective_${props.identifier}_user${props.id}`, objective);
        localStorage.setItem(`ServiceQuality_showCalls_${props.identifier}_user${props.id}`, showCalls);

        MonitorWSService.stompClient.send("/app/subscribe/servicequality", {}, JSON.stringify({
            token: props.token,
            widgetId: props.identifier,
            highQuality: highQuality,
            mediumQuality: 40,
            groupId: groupId
        }));
        setShowConfig(false);
    }

    return (

        <div className={"card card-flush overflow-hidden h-lg-20 widget-container"} >
            <div className="card-header">
                <h3 className="card-title align-items-start flex-column text-primary drag-handle">
                    <span className="card-label fw-bold text-primary"><FontAwesomeIcon icon={duotone("chart-pie-simple")} /> {t("servicequality")} - {groupName}</span>
                </h3>
                <div className="card-toolbar" style={{ zIndex: 9999 }}>
                    <button type="button" className="btn btn-sm btn-icon btn-color-primary btn-active-light-primary" onClick={toggleConfig} >
                        <FontAwesomeIcon icon={duotone("cogs")} />
                    </button>
                    <WidgetTools key={`tools_${props.identifier}`} closeWidget={closeWidget} toggleSettings={toggleSettings}></WidgetTools>
                </div>
            </div>
            <div className="card-body" style={{ "padding": "0rem 2.25rem" }}>
                {
                    showCalls &&
                    <>
                        <Row>
                            <Col className="d-flex justify-content-center align-items-center">
                                <PieChart

                                    id="servicequality"
                                    dataSource={calls}
                                    type="doughnut"
                                    resolveLabelOverlapping="shift"
                                    innerRadius={0.8}
                                    customizePoint={customizePoint}
                                    centerRender={(pie) => {
                                        return (
                                            <svg>
                                                <text textAnchor="middle" x="42" y="42" style={{ fontSize: 18, fill: localStorage.getItem("faTheme") === "light" ? '#3f4254' : "#cdcdde" }}>
                                                    <tspan x="100" style={{ fontWeight: 600, fontSize: "60px" }}>{attendedPercentage}%</tspan>
                                                </text>
                                            </svg>
                                        );
                                    }}
                                    rtlEnabled={props.rtl}
                                >
                                    <Size
                                        height={240}
                                        width={300}
                                    />
                                    <Series
                                        argumentField="state"
                                        valueField="amount"
                                    >
                                        <Connector visible={true}></Connector>
                                    </Series>
                                    <Legend visible={false}></Legend>
                                    <Animation enabled={animation}></Animation>
                                </PieChart>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <div className="fs-3hx fw-bold text-gray-800 text-center">{all}</div>
                                <div className="fs-1 fw-bold text-center">
                                    {t("all")}
                                </div>
                            </Col>
                            <Col>
                                <div className="fs-3hx fw-bold text-success text-center">{attended}</div>
                                <div className="fs-1 fw-bold text-center">{t("attended")}</div>
                            </Col>

                        </Row>

                    </>
                }
                {
                    !showCalls &&
                    <>
                        <Row>
                            <Col className="d-flex justify-content-center align-items-center ">
                                <MemoizedGauge value={highQualityPercentage} objective={objective} />
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <div className="fs-3hx fw-bold text-center" style={{ color: (highQualityPercentage > objective ? "#50cd89" : "#f1416c") }}>{highQualityPercentage}%</div>
                            </Col>
                        </Row>
                    </>
                }
            </div >
            <WidgetSettings key={`settings_${props.identifier}`} showSettings={showSettings} toggleSettings={toggleSettings} token={props.token} setGroup={setGroup} groupId={groupId} groupName={groupName} selectionType={selectionTypes.GROUP}></WidgetSettings>

            <div ref={wrapperRef} className={"menu-user menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg menu-state-color py-4 fs-6 w-400px  " + (showConfig ? "show" : "")}>
                <Row className='py-4'>
                    <Col lg={8}><Form.Label className="ms-5" htmlFor='showcalls'>{t("showcalls")}</Form.Label></Col>
                    <Col lg={4}><Switch id='showcalls' rtlEnabled={props.rtl} switchedOnText={t("yes")} switchedOffText={t("no")} value={showCalls} onValueChange={setShowCalls} text /></Col>
                </Row>
                <Row className='py-4'>
                    <Col lg={8}> <Form.Label className="ms-5" htmlFor='highqualityseconds'>{t("highqualityseconds")}</Form.Label></Col>
                    <Col lg={4}>
                        <NumberBox
                            id='highqualityseconds'
                            rtlEnabled={props.rtl}
                            showSpinButtons={true}
                            value={highQuality}
                            onValueChange={setHighQuality} />
                    </Col>
                </Row>
                <Row className='py-4'>
                    <Col lg={8}> <Form.Label className="ms-5" htmlFor='objective'>{t("objective")}</Form.Label></Col>
                    <Col lg={4}>
                        <NumberBox
                            id='objective'
                            rtlEnabled={props.rtl}
                            showSpinButtons={true}
                            value={objective}
                            onValueChange={setObjective} />
                    </Col>
                </Row>
                <div className="d-flex justify-content-end">
                    <button type="submit" className="btn btn-sm btn-primary" onClick={handleSend}>{t("send")}</button>
                </div>
            </div>
        </div >
    )
}

const mapStateToProps = (state) => {
    return {
        token: state.supervisor.token,
        connected: state.parameters.connected,
        id: state.supervisor.id,
        rtl: state.parameters.rtl
    };
};

export default connect(mapStateToProps, { removeWidget })(ServiceQuality);